import { RouteRecordRaw } from 'vue-router';
import routesMap from './routesMap';
import { isWechatBrowser } from '@/lib/utils';
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    meta: {
      module_id: 'chat',
    },
    redirect: isWechatBrowser ? '/mHome' : '/chat',
  },
  {
    path: '/chat',
    name: 'chat',
    meta: {
      keep_alive: false,
      module_id: 'chat',
    },
    component: () => import('@/views/chatroom/index.vue'),
  },
  {
    path: '/conversation',
    name: 'conversation',
    meta: {
      module_id: 'conversation',
    },
    component: () => import('@/views/conversation/index.vue'),
  },
  {
    path: '/login',
    name: 'Login',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/resetPassword',
    name: 'resetPassword',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/mLogin',
    name: 'mLogin',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/mResetPassword',
    name: 'mResetPassword',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/mBindAccount',
    name: 'mBindAccount',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/bindAccount/bindAccount.vue'),
  },
  {
    path: '/payment',
    name: 'payment',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/payment/payment.vue'),
  },
  {
    path: '/webview',
    name: 'webview',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/mobile/webview/index.vue'),
  },
  {
    path: '/officialToMini',
    name: 'officialToMini',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/mobile/webview/officialToMini.vue'),
  },
  {
    path: '/404',
    name: 'NotFound',
    meta: {
      module_id: -1,
    },
    component: () => import('@/views/404/404.vue'),
  },
  {
    path: '/:catchAll(.*)',
    meta: {
      module_id: -1,
    },
    redirect: '/404',
  },
];

export default function mergeRoutesByUser(userMap: Array<string>) {
  let tmp: any = [...routes, ...routesMap].filter((i: any) => {
    return userMap.includes(i.meta?.module_id) || i.meta?.module_id === -1;
  });
  tmp.forEach((item: any) => {
    if (item?.children?.length > 0) {
      item.children = item.children.filter((i: any) => {
        return userMap.includes(i.meta?.module_id) || i.meta?.module_id === -1;
      });
    }
  });
  return tmp;
}
